import { connect } from 'react-redux';
import Globalfilters from './Globalfilters';

import {
  fetchRegionData,
  resetRegionData,
  setSelectedRegionData,
  setSelectedCircleData,
  setSelectedCityData,
  setSelectedSitesData,
  setSelectedVendorData,
  setSelectedTechnologyData,
  setSelectedTemporalData,
  setSelectedRegionalData,
  fetchCircleData,

} from './GlobalfiltersData';

const mapDispatchToProps = {
  fetchRegionData,
  resetRegionData,
  setSelectedRegionData,
  setSelectedCircleData,
  setSelectedCityData,
  setSelectedSitesData,
  setSelectedVendorData,
  setSelectedTechnologyData,
  setSelectedTemporalData,
  setSelectedRegionalData,
  fetchCircleData
};

const mapStateToProps = (state) => ({
  fetching: state.regionReducer.fetching,
  regionData: state.regionReducer.regionData,
  selectedRegions: state.regionReducer.selectedRegions,
  selectedCircles: state.regionReducer.selectedCircles,
  selectedCities: state.regionReducer.selectedCities,
  selectedSites: state.regionReducer.selectedSites,
  selectedVendor: state.regionReducer.selectedVendor,
  selectedTechnology: state.regionReducer.selectedTechnology,
  selectedTemporal: state.regionReducer.selectedTemporal,
  selectedRegional: state.regionReducer.selectedRegional,
  circleData: state.regionReducer.circleData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Globalfilters);
